export default __webpack_public_path__ + "static/media/Arrow-Up.12803bc6.svg";